import {useEffect, useMemo, useState} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import EditorButton from "../../../../../../components/reports/editor-report/editor-button.jsx";
import EditorInput from "../../../../../../components/reports/editor-report/editor-input.jsx";

export default function IndividualNationality({ profileData, data, setMode }) {
    const [callEditor, setCallEditor] = useState(false);

    const natData = useMemo(() => {
        const source = Array.isArray(data?.individualNationality)
            ? data.individualNationality.filter(item => item?.classif === profileData?.profile)
            : [];

        return {
            labels: source.map(item => ReportUtils.formatText(item?.nationality)),
            values: source.map(item => Number(item?.qty || 0)),
        };
    },[data, profileData]);

    const chartId = `individual-nat-${profileData?.profile?.toLowerCase()?.replace(/\s+/g, "-")}`;

    useEffect(() => {
        GraphicUtils.barChart(
            chartId,
            natData.values,
            natData.labels,
        );
    }, [natData]);


    return (
        <>
            <div className="chart-report">
                <div className="flex flex-row gap-2">
                    <span className="chart-title">Nacionalidade dos indivíduos</span>
                    <EditorButton callEditor={callEditor} setCallEditor={setCallEditor}/>
                </div>

                <div className="mt-3" id={chartId}/>
            </div>

            <EditorInput callEditor={callEditor} setMode={setMode}/>

        </>
    )
}